import { SpaceModel } from "../../interfaces/Space";
import ObjectAddress from "./ObjectAddress";

type Props = {
    space: SpaceModel;
}

export default function InfoPastAddresses({ space }: Props) {

    const getPastAddresses = (space: SpaceModel) => {
        if (space.oldAddresses && space.oldAddresses.length > 0) {
            return <div>
                {space.oldAddresses.map((oldAddress) => {
                    return <ObjectAddress key={oldAddress.partOne} address={oldAddress} />
                })}
            </div>
        } else if (space.pastAddresses && space.pastAddresses.length > 0) {
            return <div>
                {space.pastAddresses.map((pastAddress) => {
                    return <div key={pastAddress}>{pastAddress}</div>;
                })}
            </div>
        }
    }

    return <div>{getPastAddresses(space)}</div>
}